import HelpIcon from "@redotech/redo-icons/help-circle.svg";
import { memo } from "react";
import { Flex } from "../../flex";
import { RedoTooltipProps, Tooltip } from "./tooltip";

export const InfoTooltip = memo(function InfoTooltip({
  tooltip,
  boxSize,
}: {
  tooltip: Omit<RedoTooltipProps, "children">;
  boxSize: number;
}) {
  return (
    <Tooltip {...tooltip}>
      <Flex tabIndex={0}>
        <HelpIcon
          style={{
            width: `${boxSize}px`,
            height: `${boxSize}px`,
            color: "var(--redo-colors-foreground-fg-tertiary)",
          }}
        />
      </Flex>
    </Tooltip>
  );
});
